const hotspotCls = "_086h1dv2muj";
const hotspotIconCls = "_086hlw28kv";

export { hotspotCls, hotspotIconCls };
import "./LinkHotspot.style.linaria.module.css";
//# sourceMappingURL=LinkHotspot.style.js.map
